/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscreated1Inputs */

const en_partnerscreated1 = /** @type {(inputs: Partnerscreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner added`)
};

const de_partnerscreated1 = /** @type {(inputs: Partnerscreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner angelegt`)
};

/**
* | output |
* | --- |
* | "Partner added" |
*
* @param {Partnerscreated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscreated1 = /** @type {((inputs?: Partnerscreated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscreated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscreated1(inputs)
	return de_partnerscreated1(inputs)
});
export { partnerscreated1 as "partnersCreated" }